export default __webpack_public_path__ + "6eec866c69313624be6061a5c86f0944.woff2";